module.exports = __webpack_public_path__ + "static/media/empty-contact-history.c9aed765.svg";